import WordMonthDate from 'Components/DateChanged/WordMonthDate/WordMonthDate';
import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import ReactDataPickerComp from 'Components/ReactDataPicker/ReactDataPickerComp';
import { useState } from 'react';

const FilterCostFix = ({
    showFilterItemCost,
    onUpdateShowFilterItemCost,
    dtStartFilter,
    dtFinishFilter,
    onUpdateDtStartFilter,
    onUpdateDtFinishFilter
}) => {
    const panelListStyle = {
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%'
    };

    const styleButtonsMonth = {
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        alignItems: 'center',
        flexDirection: 'row',
    }

    function changeShowFilterMonthPanel() {
        onUpdateShowFilterItemCost(false)
        onUpdateDtStartFilter(null)
        onUpdateDtFinishFilter(null)
    }


    function updateDtStartFilter(date) {
        if (WordMonthDate.dateFormat(date)) {
            onUpdateDtStartFilter(date)
            if (!dtFinishFilter) {
                onUpdateDtFinishFilter(new Date(date.getFullYear(), 11, date.getDate()))
            }
        }
    }

    return (
        <MiddlePanel isVisible={showFilterItemCost}>
            <Panel style={{
                width: '400px',
                height: '150px',
                borderRadius: '10px',
                backgroundColor: '#f5f5f5;',
                border: '1px solid #ccc',
                boxShadow: '0px 0px 10px rgba(0, 0, 0, 30%)'
            }}>
                <Panel titlePage={'Filtro itens pré-cadastrados'}
                    style={panelListStyle}
                    canViewCRUD={true}
                    cancelFunction={changeShowFilterMonthPanel}
                    cancelNameButton='Fechar'
                    recordsSelected={[]}
                    updating={true}
                    canSaveAfterEdit={false}>
                    <Panel style={styleButtonsMonth}>
                        <div style={{ marginLeft: '30px' }}>
                            <ReactDataPickerComp
                                selected={dtStartFilter}
                                onChange={(date) => { updateDtStartFilter(date) }}
                                className='cost-fix-width-date cursor-pointer'
                                showMonthYearPicker={true}
                                placeholderText={'Filtro inicial'}
                                dateFormat={'MM/yyyy'}
                                setter={updateDtStartFilter}
                            />
                        </div>
                        <div style={{ marginLeft: '35px' }}>
                            <ReactDataPickerComp
                                selected={dtFinishFilter}
                                onChange={(date) => { onUpdateDtFinishFilter(date) }}
                                className='cost-fix-width-date cursor-pointer'
                                showMonthYearPicker={true}
                                placeholderText={'Filtro final'}
                                dateFormat={'MM/yyyy'}
                                setter={onUpdateDtFinishFilter}
                            />
                        </div>
                    </Panel>
                </Panel>
            </Panel>
        </MiddlePanel >
    );
}

export default FilterCostFix;
